import Home from "./Home";
import OneWrapper from "./one";
import OneCollects from "./one/collects";
import OneInformation from "./one/information";

export const AdminUsersHome = Home;
export const AdminUsersOneWrapper = OneWrapper;
export const AdminUsersOneCollects = OneCollects;
export const AdminUsersOneInformation = OneInformation;